__turbopack_context__.v({
  "shopsTopPanel": "ShopsTopPanel-module-scss-module__E6Qldq__shopsTopPanel",
});
